















































































































































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import PrefillReviewList, {
  PrefillReviewItem
} from "@/components/prefill/PrefillReviewList.vue";
import FormPrefillService from "@/services/FormPrefillService";
import { userModule } from "@/store/modules/user";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { confirmRemove } from "@/utility/CommonHelper";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import Service from "@/services/AsesmenPraBedah";
import Store from "@/store/modules/AsesmenPraBedahStore";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import * as score from "@/utils/praBedahScore";
import { RCRI_KOMPONEN, STOPBANG_KOMPONEN, CAPRINI_BOBOT } from "@/utils/praBedahScore";

// Module-level agar aman dirujuk getEmptyForm() saat inisialisasi field `form`
// (field `form` diinisialisasi sebelum properti class lain pada vue-class-component).
const KOMORBID_OPTIONS = [
  { key: "hipertensi", label: "Hipertensi" },
  { key: "diabetes_melitus", label: "Diabetes Melitus" },
  { key: "penyakit_jantung", label: "Penyakit Jantung" },
  { key: "penyakit_paru", label: "Penyakit Paru (Asma/PPOK/OSA)" },
  { key: "penyakit_ginjal", label: "Penyakit Ginjal (CKD)" },
  { key: "penyakit_hati", label: "Penyakit Hati" },
  { key: "hematologi_koagulopati", label: "Hematologi / Antikoagulan" },
  { key: "kehamilan", label: "Kehamilan" },
  { key: "imunokompromais", label: "Imunokompromais" }
];

@Component({
  components: { CardModalTtd, DokterAutoComplete, PrefillReviewList },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardAsesmenPraBedah extends Mixins(PrefillMixin) {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ default: false }) readonly isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "asesmen_pra_bedah";

  prefillResolvePath(path: string) {
    if (path.indexOf("_list") !== -1) {
      return { get: () => "__skip__", set: () => undefined };
    }
    if (path === "alergi_keterangan") {
      return {
        get: () => this.form.alergi_keterangan,
        set: (v) => {
          this.form.alergi_keterangan = v;
          if (!this.form.alergi_status) this.form.alergi_status = "confirmed";
        }
      };
    }
    if (Object.prototype.hasOwnProperty.call(this.form, path)) {
      return {
        get: () => this.form[path],
        set: (v) => {
          this.form[path] = v;
        }
      };
    }
    return { get: () => "__skip__", set: () => undefined };
  }

  get prefillOperasiList(): PrefillReviewItem[] {
    const p = this.prefillPayload;
    return p && p.fields ? p.fields["riwayat.operasi_list"] || [] : [];
  }

  get prefillObatKronikList(): PrefillReviewItem[] {
    const p = this.prefillPayload;
    return p && p.fields ? p.fields["riwayat.obat_kronik_list"] || [] : [];
  }

  applyOperasiList(items: PrefillReviewItem[]) {
    const lines = items.map(it => it.value).filter(Boolean);
    if (lines.length === 0) return;
    this.form.riwayat_operasi_ada = true;
    const existing = (this.form.riwayat_operasi_terakhir || "").trim();
    this.form.riwayat_operasi_terakhir = existing
      ? existing + "; " + lines.join("; ")
      : lines.join("; ");
    this.logPrefillPartial("riwayat.operasi_list");
  }

  applyObatKronik(items: PrefillReviewItem[]) {
    const lines = items.map(it => it.value).filter(Boolean);
    if (lines.length === 0) return;
    const existing = (this.form.obat_saat_ini || "").trim();
    this.form.obat_saat_ini = existing
      ? existing + "\n" + lines.join("\n")
      : lines.join("\n");
    this.logPrefillPartial("riwayat.obat_kronik_list");
  }

  logPrefillPartial(listPath: string) {
    FormPrefillService.logAcceptance({
      form_key: this.prefillFormKey,
      pasien_rm: String(this.rm),
      register_id: this.register,
      unit_id: userModule.user ? userModule.user.unit_id : null,
      event: "partial",
      fields: [listPath],
      provenance: {},
      sources: this.prefillPayload ? this.prefillPayload.sources : []
    });
  }
  // ───────────────────────────────────────────────────────────────────

  isFormOpen = false;
  ttdDialog = false;
  markDialog = false;
  markPasienNama = "";
  saving = false;
  isEditing = false;
  editingId: number | null = null;
  signingItem: any = null;
  markingItem: any = null;
  selectedDpjp: any = null;
  menuTgl = false;
  menuJam = false;
  openPanels: number[] = [0, 1];

  form: any = this.getEmptyForm();

  urgensiOptions = [
    { text: "Elektif (Rutin)", value: "routine" },
    { text: "Urgent", value: "urgent" },
    { text: "ASAP", value: "asap" },
    { text: "Cito / Emergensi", value: "stat" }
  ];
  lateralitasOptions = [
    { text: "Kanan", value: "kanan" },
    { text: "Kiri", value: "kiri" },
    { text: "Bilateral", value: "bilateral" },
    { text: "Tidak Relevan", value: "tidak_relevan" }
  ];
  lateralitasSisiOptions = [
    { text: "Kanan", value: "kanan" },
    { text: "Kiri", value: "kiri" },
    { text: "Bilateral", value: "bilateral" }
  ];
  alergiOptions = [
    { text: "Tidak Ada Alergi (NKA)", value: "nka" },
    { text: "Terkonfirmasi", value: "confirmed" },
    { text: "Belum Terkonfirmasi", value: "unconfirmed" }
  ];
  merokokOptions = [
    { text: "Perokok Aktif", value: "aktif" },
    { text: "Mantan Perokok", value: "mantan" },
    { text: "Tidak Merokok", value: "tidak" }
  ];
  komorbidOptions = KOMORBID_OPTIONS;
  asaOptions = [
    { text: "ASA I — Pasien sehat", value: "I" },
    { text: "ASA II — Penyakit sistemik ringan", value: "II" },
    { text: "ASA III — Penyakit sistemik berat", value: "III" },
    { text: "ASA IV — Mengancam jiwa", value: "IV" },
    { text: "ASA V — Moribund", value: "V" },
    { text: "ASA VI — Mati batang otak (donor)", value: "VI" }
  ];
  kelayakanOptions = [
    { text: "Layak Operasi", value: "layak" },
    { text: "Layak dengan Optimisasi", value: "layak_optimisasi" },
    { text: "Tunda — Butuh Evaluasi", value: "tunda" },
    { text: "Tidak Layak", value: "tidak_layak" }
  ];
  pendekatanOptions = [
    { text: "Terbuka", value: "terbuka" },
    { text: "Laparoskopik", value: "laparoskopik" },
    { text: "Robotik", value: "robotik" },
    { text: "Endoskopik", value: "endoskopik" },
    { text: "Minimal Invasif", value: "minimal_invasif" }
  ];
  anestesiOptions = [
    { text: "Umum (GA)", value: "umum" },
    { text: "Spinal", value: "spinal" },
    { text: "Epidural", value: "epidural" },
    { text: "Kombinasi", value: "kombinasi" },
    { text: "Regional Blok", value: "regional_blok" },
    { text: "Lokal", value: "lokal" },
    { text: "MAC / Sedasi", value: "mac_sedasi" }
  ];
  icuOptions = [
    { text: "Ya — Rutin", value: "ya_rutin" },
    { text: "Ya — Kondisional", value: "ya_kondisional" },
    { text: "Tidak", value: "tidak" }
  ];

  get masters() {
    return Store.masters;
  }
  get dataList() {
    return Store.dataList;
  }
  get loading() {
    return Store.loading;
  }

  get liveImt(): number | null {
    return score.hitungImt(this.form.bb, this.form.tb);
  }

  get liveAsaLabel(): string | null {
    return score.asaLabel(this.form.asa_klasifikasi, this.form.asa_emergency);
  }

  get asaColorLive(): string {
    return this.asaColor(this.form.asa_klasifikasi);
  }

  get isTandaX(): boolean {
    return (this.form.penandaan_jenis_tanda || "").trim().toUpperCase() === "X";
  }

  /** Skor live dengan faktor objektif diturunkan (kreatinin, IMT). */
  get live() {
    const imt = this.liveImt;
    const rcri = { ...this.form.rcri_input };
    if (this.form.lab_kreatinin !== null && this.form.lab_kreatinin !== "" && this.form.lab_kreatinin !== undefined) {
      rcri.kreatinin_lebih_2 = Number(this.form.lab_kreatinin) > 2;
    }
    const caprini = { ...this.form.caprini_input };
    const stopbang = { ...this.form.stopbang_input };
    if (imt !== null) {
      caprini.imt_gt_25 = imt > 25;
      stopbang.imt_gt_35 = imt > 35;
    }
    const rcriSkor = score.rcriSkor(rcri);
    const capriniSkor = score.capriniSkor(caprini);
    const stopbangSkor = score.stopbangSkor(stopbang);
    return {
      rcri_skor: rcriSkor,
      rcri_risiko: score.rcriRisiko(rcriSkor),
      caprini_skor: capriniSkor,
      caprini_kategori: score.capriniKategori(capriniSkor),
      stopbang_skor: stopbangSkor,
      stopbang_risiko: score.stopbangRisiko(stopbangSkor)
    };
  }

  mounted() {
    if (this.isActive) {
      this.init();
    }
  }

  @Watch("isActive")
  onActiveChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  async init() {
    await Store.loadMasters();
    await Store.getByRegister(this.register);
  }

  seedMap(keys: string[]): Record<string, boolean> {
    const obj: Record<string, boolean> = {};
    keys.forEach(k => {
      obj[k] = false;
    });
    return obj;
  }

  getEmptyForm() {
    const now = moment();
    return {
      tgl_asesmen_date: now.format("YYYY-MM-DD"),
      tgl_asesmen_time: now.format("HH:mm"),
      urgensi: "routine",
      rencana_operasi_at: "",
      diagnosa_prabedah: "",
      diagnosa_icd10: "",
      diagnosa_sekunder: "",
      lateralitas: null,
      lokasi_anatomis: "",
      indikasi_operasi: "",
      riwayat_operasi_ada: false,
      riwayat_operasi_terakhir: "",
      alergi_status: null,
      alergi_keterangan: "",
      komorbid: this.seedMap(KOMORBID_OPTIONS.map(k => k.key)),
      obat_saat_ini: "",
      obat_dihentikan: "",
      puasa_makan_terakhir: "",
      puasa_minum_terakhir: "",
      status_merokok: null,
      ku: "",
      kesadaran: "",
      td_sistol: null,
      td_diastol: null,
      nadi: null,
      laju_napas: null,
      suhu: null,
      spo2: null,
      bb: null,
      tb: null,
      skala_nyeri: null,
      pf_kepala_leher: "",
      pf_mulut_gigi: "",
      mallampati: null,
      pf_thorax: "",
      pf_abdomen: "",
      pf_kardiovaskuler: "",
      pf_genitourinaria: "",
      pf_muskuloskeletal: "",
      pf_alat_reproduksi: "",
      pf_kulit: "",
      pf_neurologis: "",
      pp_lab: "",
      lab_kreatinin: null,
      pp_ekg: "",
      pp_radiologi: "",
      pp_lain: "",
      pp_kesimpulan: "",
      asa_klasifikasi: null,
      asa_emergency: false,
      rcri_input: this.seedMap(RCRI_KOMPONEN),
      caprini_input: this.seedMap(Object.keys(CAPRINI_BOBOT)),
      stopbang_input: this.seedMap(STOPBANG_KOMPONEN),
      vte_profilaksis: "",
      kelayakan_operasi: null,
      kesan_klinis: "",
      catatan_optimisasi: "",
      perlu_penandaan: false,
      penandaan_alasan_tidak: "",
      penandaan_lokasi: "",
      penandaan_sisi: null,
      penandaan_jenis_tanda: "",
      penandaan_pelibatan_pasien: false,
      rencana_tindakan: "",
      rencana_icd9cm: "",
      pendekatan_operasi: null,
      posisi_operasi: "",
      estimasi_durasi: null,
      estimasi_pendarahan: null,
      jenis_anestesi_rencana: null,
      kebutuhan_darah: "",
      kebutuhan_implan: "",
      kebutuhan_icu: null,
      kebutuhan_pa: false,
      persiapan_khusus: "",
      alternatif_tindakan: "",
      catatan_khusus: "",
      dpjp_id: null
    };
  }

  addNew() {
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();

    // RAN-051: prefill alergi dari data kanonik pasien (record baru).
    const alergiKanonik = storePasien.identitasPasien?.alergi;
    if (alergiKanonik && !this.form.alergi_keterangan) {
      this.form.alergi_status = "confirmed";
      this.form.alergi_keterangan = alergiKanonik;
    }

    this.selectedDpjp = null;
    this.openPanels = [0, 1];
    this.isFormOpen = true;

    // Soft-prefill: hanya field kosong (TTV/nyeri/BB-TB register ini +
    // saran riwayat operasi & obat kronik). Tidak pada editItem().
    if (!this.readOnly) {
      this.$nextTick(() => {
        this.loadPrefill({
          pasien_rm: String(this.rm),
          register_id: this.register,
          unit_id: userModule.user ? userModule.user.unit_id : undefined
        });
      });
    }
  }

  editItem(item: any) {
    this.isEditing = true;
    this.editingId = item.id;
    const tgl = moment(item.tgl_asesmen);
    const empty = this.getEmptyForm();
    this.form = {
      ...empty,
      ...item,
      tgl_asesmen_date: tgl.format("YYYY-MM-DD"),
      tgl_asesmen_time: tgl.format("HH:mm"),
      rencana_operasi_at: item.rencana_operasi_at ? moment(item.rencana_operasi_at).format("YYYY-MM-DDTHH:mm") : "",
      puasa_makan_terakhir: item.puasa_makan_terakhir ? moment(item.puasa_makan_terakhir).format("YYYY-MM-DDTHH:mm") : "",
      puasa_minum_terakhir: item.puasa_minum_terakhir ? moment(item.puasa_minum_terakhir).format("YYYY-MM-DDTHH:mm") : "",
      komorbid: { ...empty.komorbid, ...(item.komorbid || {}) },
      rcri_input: { ...empty.rcri_input, ...(item.rcri_input || {}) },
      caprini_input: { ...empty.caprini_input, ...(item.caprini_input || {}) },
      stopbang_input: { ...empty.stopbang_input, ...(item.stopbang_input || {}) }
    };
    this.selectedDpjp = item.dpjp
      ? { id: item.dpjp_id, nama: item.dpjp.identitas?.nama || "" }
      : null;
    this.openPanels = [0, 1];
    this.isFormOpen = true;
  }

  closeForm() {
    this.isFormOpen = false;
    this.form = this.getEmptyForm();
    this.selectedDpjp = null;
  }

  onDpjpSelected(dokter: any) {
    if (dokter && dokter.id) {
      this.form.dpjp_id = dokter.id;
      this.selectedDpjp = dokter;
    }
  }

  buildPayload() {
    const f = this.form;
    const tglAsesmen = `${f.tgl_asesmen_date} ${f.tgl_asesmen_time}:00`;
    const dt = (v: any) => (v ? moment(v).format("YYYY-MM-DD HH:mm:ss") : null);
    return {
      register_id: this.register,
      pasien_rm: String(this.rm),
      tgl_asesmen: tglAsesmen,
      urgensi: f.urgensi,
      rencana_operasi_at: dt(f.rencana_operasi_at),
      diagnosa_prabedah: f.diagnosa_prabedah,
      diagnosa_icd10: f.diagnosa_icd10 || null,
      diagnosa_sekunder: f.diagnosa_sekunder || null,
      lateralitas: f.lateralitas,
      lokasi_anatomis: f.lokasi_anatomis || null,
      indikasi_operasi: f.indikasi_operasi,
      riwayat_operasi_ada: f.riwayat_operasi_ada,
      riwayat_operasi_terakhir: f.riwayat_operasi_ada ? f.riwayat_operasi_terakhir || null : null,
      alergi_status: f.alergi_status,
      alergi_keterangan: f.alergi_status === "confirmed" ? f.alergi_keterangan || null : null,
      komorbid: f.komorbid,
      obat_saat_ini: f.obat_saat_ini || null,
      obat_dihentikan: f.obat_dihentikan || null,
      puasa_makan_terakhir: dt(f.puasa_makan_terakhir),
      puasa_minum_terakhir: dt(f.puasa_minum_terakhir),
      status_merokok: f.status_merokok,
      ku: f.ku || null,
      kesadaran: f.kesadaran || null,
      td_sistol: f.td_sistol,
      td_diastol: f.td_diastol,
      nadi: f.nadi,
      laju_napas: f.laju_napas,
      suhu: f.suhu,
      spo2: f.spo2,
      bb: f.bb,
      tb: f.tb,
      skala_nyeri: f.skala_nyeri,
      pf_kepala_leher: f.pf_kepala_leher || null,
      pf_mulut_gigi: f.pf_mulut_gigi || null,
      mallampati: f.mallampati,
      pf_thorax: f.pf_thorax || null,
      pf_abdomen: f.pf_abdomen || null,
      pf_kardiovaskuler: f.pf_kardiovaskuler || null,
      pf_genitourinaria: f.pf_genitourinaria || null,
      pf_muskuloskeletal: f.pf_muskuloskeletal || null,
      pf_alat_reproduksi: f.pf_alat_reproduksi || null,
      pf_kulit: f.pf_kulit || null,
      pf_neurologis: f.pf_neurologis || null,
      pp_lab: f.pp_lab || null,
      lab_kreatinin: f.lab_kreatinin,
      pp_ekg: f.pp_ekg || null,
      pp_radiologi: f.pp_radiologi || null,
      pp_lain: f.pp_lain || null,
      pp_kesimpulan: f.pp_kesimpulan || null,
      asa_klasifikasi: f.asa_klasifikasi,
      asa_emergency: f.asa_emergency,
      rcri_input: f.rcri_input,
      caprini_input: f.caprini_input,
      vte_profilaksis: f.vte_profilaksis || null,
      stopbang_input: f.stopbang_input,
      kelayakan_operasi: f.kelayakan_operasi,
      kesan_klinis: f.kesan_klinis || null,
      catatan_optimisasi: f.catatan_optimisasi || null,
      perlu_penandaan: f.perlu_penandaan,
      penandaan_alasan_tidak: f.perlu_penandaan ? null : f.penandaan_alasan_tidak || null,
      penandaan_lokasi: f.perlu_penandaan ? f.penandaan_lokasi || null : null,
      penandaan_sisi: f.perlu_penandaan ? f.penandaan_sisi : null,
      penandaan_jenis_tanda: f.perlu_penandaan ? f.penandaan_jenis_tanda || null : null,
      penandaan_pelibatan_pasien: f.perlu_penandaan ? f.penandaan_pelibatan_pasien : null,
      rencana_tindakan: f.rencana_tindakan,
      rencana_icd9cm: f.rencana_icd9cm || null,
      pendekatan_operasi: f.pendekatan_operasi,
      posisi_operasi: f.posisi_operasi || null,
      estimasi_durasi: f.estimasi_durasi,
      estimasi_pendarahan: f.estimasi_pendarahan,
      jenis_anestesi_rencana: f.jenis_anestesi_rencana,
      kebutuhan_darah: f.kebutuhan_darah || null,
      kebutuhan_implan: f.kebutuhan_implan || null,
      kebutuhan_icu: f.kebutuhan_icu,
      kebutuhan_pa: f.kebutuhan_pa,
      persiapan_khusus: f.persiapan_khusus || null,
      alternatif_tindakan: f.alternatif_tindakan || null,
      catatan_khusus: f.catatan_khusus || null,
      dpjp_id: f.dpjp_id
    };
  }

  async saveForm() {
    if (this.isTandaX) {
      appModule.NoticeDelay('Tanda "X" tidak diperbolehkan (ambigu).');
      return;
    }
    this.saving = true;
    try {
      const payload = this.buildPayload();
      if (this.isEditing && this.editingId) {
        await Service.update(this.editingId, payload);
        appModule.NoticeDelay("Berhasil memperbarui Asesmen Pra Bedah");
      } else {
        await Service.create(payload);
        appModule.NoticeDelay("Berhasil menyimpan Asesmen Pra Bedah");
      }
      this.closeForm();
      this.init();
    } catch (err) {
      // error handled by service
    } finally {
      this.saving = false;
    }
  }

  bisaHapus(item: any): boolean {
    if (this.readOnly) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [{ ditandatangani: item.signed_dpjp, penandaTanganId: item.dpjp_id }],
      userModule.user?.id
    );
  }

  removeItem(item: any) {
    if (!this.bisaHapus(item)) return;
    if (confirmRemove("Asesmen Pra Bedah")) {
      Service.destroy(item.id).then(resp => {
        if (Number(resp.status) === 1) {
          appModule.NoticeDelay("Berhasil menghapus Asesmen Pra Bedah");
          this.init();
        }
      });
    }
  }

  openSign(item: any) {
    this.signingItem = item;
    this.ttdDialog = true;
  }

  async submitSign(password: string) {
    if (!this.signingItem) return;
    try {
      const resp = await Service.signDpjp(this.signingItem.id, { password });
      if (Number(resp.status) === 1) {
        appModule.NoticeDelay("Berhasil menandatangani Asesmen Pra Bedah");
        this.init();
      }
    } catch (err) {
      // handled
    }
    this.signingItem = null;
  }

  openMarkPasien(item: any) {
    this.markingItem = item;
    this.markPasienNama = item.pasien_nama || (item.pasien ? item.pasien.nama : "") || "";
    this.markDialog = true;
  }

  async submitMarkPasien() {
    if (!this.markingItem) return;
    try {
      const resp = await Service.markPasien(this.markingItem.id, { pasien_nama: this.markPasienNama });
      if (Number(resp.status) === 1) {
        appModule.NoticeDelay("Berhasil menandai pasien/wali");
        this.markDialog = false;
        this.init();
      }
    } catch (err) {
      // handled
    }
    this.markingItem = null;
  }

  printPdf(id: number) {
    Service.print(id);
  }

  // ===== Display helpers =====
  formatDate(d: string): string {
    return d ? moment(d).format("DD-MM-YYYY HH:mm") : "-";
  }
  asaColor(asa: string | null): string {
    const map: Record<string, string> = { I: "green", II: "blue", III: "orange", IV: "red darken-1", V: "red darken-4", VI: "black" };
    return asa ? map[asa] || "grey" : "grey";
  }
  asaLabelOf(item: any): string {
    return score.asaLabel(item.asa_klasifikasi, item.asa_emergency) || "ASA -";
  }
  riskColorOf(v: string | null): string {
    return score.riskColor(v);
  }
  riskText(v: string | null): string {
    return score.riskLabel(v);
  }
  urgensiLabel(v: string): string {
    const o = this.urgensiOptions.find(x => x.value === v);
    return o ? o.text : v || "-";
  }
  kelayakanLabel(v: string): string {
    const o = this.kelayakanOptions.find(x => x.value === v);
    return o ? o.text : v || "-";
  }
  kelayakanColor(v: string): string {
    const map: Record<string, string> = { layak: "green", layak_optimisasi: "teal", tunda: "orange", tidak_layak: "red" };
    return map[v] || "grey";
  }
  dpjpName(item: any): string {
    return item.dpjp?.identitas?.nama || "-";
  }
}
